import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'lib-legal-guarantee-page',
    standalone: true,
    imports: [NgOptimizedImage],
    template: `
        <main class="inner-page-wrapper py-40 md:py-[80px]">
            <h1 class="font-headline text-20 md:text-34 mb-24 leading-25 font-medium text-black md:leading-41">
                Gesetzliche Gewährleistung
            </h1>
            <img
                class="block h-auto w-full max-w-[880px]"
                ngSrc="/assets/images/legal-guarantee/Legal-guarantee-harmonised-notice_de.jpg"
                width="880"
                height="1199"
                alt="Label zum gesetzlichen Gewährleistungshinweis"
            />
        </main>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalGuaranteePageComponent {}
